import React, {useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {isMobile, trackMoengageEvent} from '../../../utils/commonMethods';

import FastImage from "../../../common/FastImage";
import {email_black, phone_black, successfulCall} from "../../../utils/images";
import EmailBottomSheet from "./EmailBottomSheet";
import EmailEnterSheet from "./EmailEnterSheet";
import GoogleLoginRT from "../../../common/googleLogin";
import {globalConst} from "../../../utils/globalConstant";
import Toast from "react-native-toast-message";
import {Network} from "../../../utils/network";
import {getUser} from "../redux/profile.action";
import MobileOTPVerification from "../../Login/MobileOTPVerification";

function MobileEmailBottomSheet({
    mobileEmailSheet, 
    setMobileEmailSheet, 
    responseGoogleSuccess, 
    responseGoogleError,
    showMobileOnly,
    isProfile
}) {
    const dispatch = useDispatch();
    const [changeValue, setchangeValue] = useState(false);

    const onFormSubmit = async (data) => {
        responseGoogleSuccess(data);
        await dispatch(getUser());
        setMobileEmailSheet(false);
    };

    return (
        <>
            {!changeValue ? (
                <View
                    style={{
                        paddingTop: 20,
                        height: '100%',
                    }}>
                    <View style={{paddingHorizontal: 16, marginBottom: 10}}>
                        <Text
                            style={{
                                ...globalFontStyle.appFontTitle,
                                color: Colors.black,
                                paddingBottom: 5,
                                textAlign: 'center'
                            }}>
                            {mobileEmailSheet === 'email' ? 'Verify Email' : 'Verify Phone Number'}
                        </Text>
                        <Text
                            style={{
                                ...globalFontStyle.appFontHeadingRegular,
                                color: Colors.lightgrey,
                                textAlign: 'center',
                                marginTop: 8
                            }}>
                            {mobileEmailSheet === 'email' 
                                ? "Please verify your email to continue" 
                                : "Please verify your phone number to continue"}
                        </Text>
                    </View>

                    <View
                        style={{
                            marginTop: 20,
                            paddingBottom: 15,
                            marginHorizontal: 16,
                        }}>
                        <View style={{}}>
                            {mobileEmailSheet === 'email' && !showMobileOnly && (
                                <GoogleLoginRT
                                    googleClientId={globalConst?.googleClientId}
                                    responseGoogle={onFormSubmit}
                                    responseGoogleError={responseGoogleError}
                                />
                            )}
                            <TouchableOpacity 
                                style={[styles.buttonStyle, {marginTop: mobileEmailSheet === 'email' && !showMobileOnly ? 15 : 0}]}
                                onPress={()=>{setchangeValue(true)}}
                            >
                                <View style={{position: 'absolute', left: 20}}>
                                    <FastImage
                                        source={mobileEmailSheet === 'email' ? email_black() : phone_black()}
                                        style={{ height: 22, width: 22, }}
                                    />
                                </View>
                                <Text style={{...globalFontStyle.appFontBody, color: Colors.black}}>
                                    {mobileEmailSheet === 'email' ? 'Continue with Email' : 'Verify via OTP'}
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            ) : (
                <>
                    {mobileEmailSheet === 'email' ? (
                        <EmailEnterSheet 
                            mobileEmailSheet={mobileEmailSheet} 
                            setMobileEmailSheet={setMobileEmailSheet} 
                        />
                    ) : (
                        <MobileOTPVerification 
                            onBottomSheetClose={async ()=>{
                                await dispatch(getUser());
                                setMobileEmailSheet(false);
                            }}
                            isProfile={isProfile}
                            showMobileOnly={showMobileOnly}
                        />
                    )}
                </>
            )}
        </>
    );
}

export default MobileEmailBottomSheet;

const styles = StyleSheet.create({
    buttonStyle : {
        paddingVertical: isMobile() ? 18 : 14,
        flex: 1,
        alignItems: "center",
        borderRadius: 8,
        flexDirection: 'row',
        backgroundColor: Colors.grey4,
        justifyContent: 'center',
        marginBottom: 15
    }
});
